import { Avatar, Box, Card, Typography } from "@mui/material";
import { blue, green, lightBlue, lightGreen, orange, purple, red } from "@mui/material/colors";

export default function ServiceTicket(props) {
  const { ticket } = props;

  const colours = [
    blue[800],
    green[500],
    purple[800],
    red[800],
    lightBlue[900],
    lightGreen[700],
    blue[900],
    green[900],
    orange[900],
    purple[900],
  ];
  const getColour = colours[Math.floor(Math.random() * colours.length)];

  return (
    <Card {...props}>
      <Box
        p={3}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          cursor: "pointer",
        }}
      >
        <Avatar sx={{ bgcolor: getColour, mb: 2, width: 56, height: 56 }} size="large">
          {ticket.count}
        </Avatar>
        <Typography noWrap variant="h2" fontSize={14} color={getColour}>
          {ticket.serviceName}
        </Typography>
      </Box>
    </Card>
  );
}
